import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

@Component({
    template: `
        <div class="hour-container">
            <strong>Horários:</strong>
            <p *ngFor="let hour of hours">{{hour.weekday}} - {{hour.start_hour}}h às {{hour.final_hour}}h</p>
        </div>
    `,
    styles: [`
        .hour-container {
            padding: 20px;
        }
    `]
})
export class PopoverHorariosComponent {

    private hours: string[];

    constructor(public viewCtrl: ViewController) {
        this.hours = viewCtrl.data;
    }
}


// WEBPACK FOOTER //
// ./src/components/popover-horarios/popover-horarios.ts